module.exports = __webpack_public_path__ + "img/Environment.7dd2bade.svg";